import { useEffect, useState } from 'react';
import { authHeaders, userHeaders } from '../utils/api';

function useFetchApi({
    url,
    dataKey,
    authType = null // "admin" | "user"
}) {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchData = async () => {
        try {
            setLoading(true);
            setError(null);

            let headers = {
                Accept: "application/json",
            };

            if (authType === "admin") {
                headers = authHeaders();
            }

            if (authType === "user") {
                headers = userHeaders();
            }

            const res = await fetch(url, {
                method: "GET",
                headers,
            });

            if (!res.ok) {
                throw new Error(`Server Error: ${res.status}`);
            }

            const result = await res.json();

            if (Array.isArray(result)) {
                setData(result);
            } else if (dataKey && result[dataKey]) {
                setData(result[dataKey]);
            } else {
                setData(result);
            }

        } catch (error) {
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (url) {
            fetchData();
        }
    }, [url]);

    return {
        data,
        setData,
        loading,
        error,
        refetch: fetchData,
    };
}

export default useFetchApi;